module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.renameShow) ? _c('div', {
    staticClass: "rename-cover"
  }, [_c('div', {
    staticClass: "rename"
  }, [_c('h3', {
    staticClass: "rename-title"
  }, [_vm._v("重名文件处理")]), _c('div', {
    staticClass: "rename-item-container"
  }, _vm._l((_vm.optionArr), function(v, i) {
    return _c('div', {
      staticClass: "rename-item",
      on: {
        "click": function($event) {
          _vm.enterRenameState($event, i)
        }
      }
    }, [_c('input', {
      staticClass: "file-name-input",
      class: {
        'repeat-error': v.error, 'correct': !v.error
      },
      attrs: {
        "spellcheck": "false",
        "disabled": v.selected === '重命名' ? false : true
      },
      domProps: {
        "value": v.rename
      },
      on: {
        "input": function($event) {
          _vm.checkName($event, i)
        },
        "click": function($event) {
          _vm.enterRenameState($event, i)
        }
      }
    }), _c('select', {
      domProps: {
        "value": v.selected
      },
      on: {
        "change": function($event) {
          _vm.selectChange($event, i)
        }
      }
    }, _vm._l((_vm.optionList), function(v1) {
      return _c('option', [_vm._v(_vm._s(v1))])
    }))])
  })), _c('div', {
    staticClass: "batch-operation"
  }, [_c('a', {
    staticClass: "all-replace",
    class: {
      active: _vm.allReplace
    },
    on: {
      "click": _vm.setAllReplace
    }
  }, [_vm._v("全部覆盖")]), _c('a', {
    staticClass: "all-cancel",
    class: {
      active: _vm.allCancel
    },
    on: {
      "click": _vm.setAllCancel
    }
  }, [_vm._v("全部抛弃")])]), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    staticClass: "sure",
    on: {
      "click": _vm.rename
    }
  }, [_vm._v("确定")])]), (_vm.passAllErrorShow) ? _c('div', {
    staticClass: "passAll-error"
  }, [_vm._v("验证未全部通过")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9db9202e"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rename/rename.vue
// module id = 281
// module chunks = 1